import { DNA } from '../visual-language'
import { calcLineHeight } from '../utils'
import { LevelProps } from './tokens'

export const textStyles = ({ level = 'medium' }: TextStylesProps = {}) => ({
  ...levelStyles[level],
})

const levelStyles = {
  xlarge: {
    fontSize: DNA.tokens.dimension.font[300],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[300],
      lineHeight: 1.5,
    }),
  },
  large: {
    fontSize: DNA.tokens.dimension.font[200],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[200],
      lineHeight: 1.5,
    }),
  },
  medium: {
    fontSize: DNA.tokens.dimension.font[100],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[100],
      lineHeight: 1.5,
    }),
  },
  small: {
    fontSize: DNA.tokens.dimension.font[75],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[75],
      lineHeight: 1.5,
    }),
  },
  xsmall: {
    fontSize: DNA.tokens.dimension.font[50],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[50],
      lineHeight: 1.5,
    }),
  },
}

export interface TextStylesProps extends Partial<LevelProps> {}
